import React, { useEffect, useState, useRef } from 'react';
import { useAccount } from 'wagmi';
import { Grid } from '@mui/material';

import { lsKey, useUserContext } from '../context/user.context';
import CustomModal from '../Components/Modal/CustomModal';
import { useWalletAgreement } from '../Pages/Vaults/useAgreements';

export default function ConnectButton({ title = 'Connect Wallet' }) {
  const { address, isConnected } = useAccount();
  const { setIsLoggedIn } = useUserContext();
  const [showModal, setShowModal] = useState(false);
  let isAlreadyAcceptted = false;
  const [canShowRealButton, setCanShowRealButton] =
    useState(isAlreadyAcceptted);
  const { acceptAgreement } = useWalletAgreement();

  useEffect(() => {
    if (!isConnected && !address) {
      localStorage.removeItem(lsKey);
      setIsLoggedIn(false);
      if (!isAlreadyAcceptted) {
        setCanShowRealButton(false);
      }
    } else {
      setCanShowRealButton(true);
    }
  }, [address, isConnected, setIsLoggedIn]);

  const handleConfirmAgreement = () => {
    setShowModal(false);
    setCanShowRealButton(true);
  };

  return (
    <>
      {!canShowRealButton && (
        <button
          onClick={() => {
            setShowModal(true);
            acceptAgreement();
          }}
          className="fakeConnectButton"
        >
          {title}
        </button>
      )}
      {/* @ts-expect-error msg */}
      {canShowRealButton && <appkit-button balance="hide" label={title} />}
      {showModal && (
        <CustomModal
          open={showModal}
          setOpen={() => setShowModal(false)}
          modalTitle={''}
          width={{ lg: '30%', md: '30%', xs: '90%', sm: '90%' }}
          scrollable={false}
          closebtn={true}
          height="auto"
          transparent={false}
          modalContent={
            <Grid
              container
              lg={12}
              display={'flex'}
              flexDirection={'row'}
              alignItems={'center'}
              justifyContent={'center'}
            >
              <Grid
                item
                lg={12}
                md={12}
                display="flex"
                flexDirection={'column'}
                alignItems={'center'}
                justifyContent={'center'}
                gap={'20px'}
              >
                <p style={{ textAlign: 'center', fontSize: '17px' }}>
                  By proceeding you have read, agree to and accept the <br />
                  <a
                    href="/pdf/OpenZK.-.Token.T.Cs.250526.pdf"
                    target="_blank"
                    className="landingPtag2"
                    style={{ fontSize: '14px' }}
                  >
                    Terms and Conditions of Holding and Usage of OZK Tokens
                  </a>
                  <br />
                  and{' '}
                  <a
                    href="/pdf/OpenZK_Terms.of.Use_250620.pdf"
                    target="_blank"
                    className="landingPtag2"
                    style={{ fontSize: '14px' }}
                  >
                    Terms of Use
                  </a>
                </p>

                <span onClick={handleConfirmAgreement}>
                  {/* @ts-expect-error msg */}
                  <appkit-button balance="hide" label={'Agree and Accept'} />
                </span>
              </Grid>
            </Grid>
          }
        />
      )}
    </>
  );
}
